export const CREATE_INDEPENDENT_TICKETS_REQUEST = "CREATE_INDEPENDENT_TICKETS_REQUEST"
export const CREATE_INDEPENDENT_TICKETS_FAILURE = "CREATE_INDEPENDENT_TICKETS_FAILURE"
export const CREATE_INDEPENDENT_TICKETS_SUCCESS = "CREATE_INDEPENDENT_TICKETS_SUCCESS"
export const VIEW_TICKET_SUCCESS = "VIEW_TICKET_SUCCESS";
export const TICKETS_LIST_REQUEST = "TICKETS_LIST_REQUEST";
export const VIEW_TICKET_FAILURE = "VIEW_TICKET_FAILURE";
export const RESET_TICKETS_STORE_SUCCESS = "RESET_TICKETS_STORE_SUCCESS";
export const RESET_TICKETS_STORE_REQUEST = "RESET_TICKETS_STORE_REQUEST";
export const VIEW_TICKET_REQUEST = "VIEW_TICKET_REQUEST";
export const GET_TICKET_PAYMENTS_REQUEST = "GET_TICKET_PAYMENTS_REQUEST";
export const TICKETS_COUNT_SUCCESS = "TICKETS_COUNT_SUCCESS";
export const UPDATE_TICKETS_LAST_SCANNED_INDEX_SUCCESS = "UPDATE_TICKETS_LAST_SCANNED_INDEX_SUCCESS";
export const TICKETS_LIST_SUCCESS = "TICKETS_LIST_SUCCESS";
export const TICKETS_LIST_FAILURE = "TICKETS_LIST_FAILURE";
      